import React, { useState, useEffect } from "react";
import CardGrid from "./CardGrid";
import "./LeadsForm.scss";
import Modal from "../../../components/Modal";
import arrowForward from "../../../assets/images/leads/ArrowRight.svg";
import LeadsSubmissionForm from "../../../components/LeadsSubmissionForm";

function getParamsFromUrl() {
  const p = new URLSearchParams(window.location.search);
  return {
    type: p.get("type") || "",
    quantity: p.get("quantity") || "",
    phone: p.get("phone") || "",
  };
}

export default function LeadsForm() {
  const initial = getParamsFromUrl();
  const [open, setOpen] = useState(!!initial.type);
  const [selectedType, setSelectedType] = useState(initial.type);
  const [quantity, setQuantity] = useState(initial.quantity);
  const [phone, setPhone] = useState(initial.phone);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
  const [openedFromButton, setOpenedFromButton] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (selectedType) p.set("type", selectedType);
    else p.delete("type");
    if (quantity) p.set("quantity", quantity);
    else p.delete("quantity");
    if (phone) p.set("phone", phone);
    else p.delete("phone");

    const newUrl = `${window.location.pathname}?${p.toString()}`;
    window.history.replaceState({}, "", newUrl);
  }, [selectedType, quantity, phone]);

  function openFormWith(type) {
    setSelectedType(type);
    setOpenedFromButton(false);
    setOpen(true);
  }

  function openFromButton() {
    setOpenedFromButton(true);
    setOpen(true);
  }
  function closeModal() {
    const p = new URLSearchParams(window.location.search);
    p.delete("type");
    p.delete("quantity");
    p.delete("phone");

    const newUrl = `${window.location.pathname}${p.toString()}`;
    window.history.replaceState({}, "", newUrl);
    setOpen(false);
    setIsSubmitSuccessful(false);
    setOpenedFromButton(false);
  }

  return (
    <div>
      <main className="leads_container">
        <h1 className="leads_heading">Buy Bulk Fabric at BEST PRICES</h1>
        <CardGrid onCardClick={openFormWith} />
        <div className="btn-wrapper">
          <button className="custom-btn-primary" onClick={openFromButton}>
            Share your requirement
            <img
              className="hero_arrow_leads"
              src={arrowForward}
              alt="icon"
              loading="lazy"
            />
          </button>
        </div>
      </main>
      <Modal
        title={!isSubmitSuccessful ? "Fill your details" : ""}
        show={open}
        _handleClose={() => {
          closeModal();
        }}
      >
        <LeadsSubmissionForm
          closedText={"Close"}
          submitText={"Submit"}
          _handleClose={() => {
            closeModal();
          }}
          isSubmitSuccessful={isSubmitSuccessful}
          setSubmitSuccess={setIsSubmitSuccessful}
          fillDetails={false}
          requirementFormClass={"herorequirementFormClass"}
          formType={"leads"}
          fabricType={selectedType}
          openedFromButton={openedFromButton}
        />
      </Modal>
    </div>
  );
}
